import {
  ChangeDetectorRef,
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DashboardItemSettingsComponent } from '../dashboard-item-settings.component';
import { DashboardItemTypeValueDisplay } from '../../models/DashboardItemTypeValueDisplay';
import { DataDisplayDefaultRanges } from '../../../../shared/models/DataDisplayDefaultRanges';
import { ValueDisplayMode } from './ValueDisplayMode.model';
import { of } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MatSliderModule } from '@angular/material/slider';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { DashboardValueDisplaySettingsInputComponent } from './dashboard-value-display-settings-input/dashboard-value-display-settings-input.component';

@Component({
  selector: 'app-dashboard-value-display-settings',
  templateUrl: './dashboard-value-display-settings.component.html',
  styleUrls: ['./dashboard-value-display-settings.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatCheckboxModule,
    ReactiveFormsModule,
    FormsModule,
    MatSliderModule,
    TranslateModule,
    DashboardValueDisplaySettingsInputComponent,
  ],
})
export class DashboardValueDisplaySettingsComponent
  extends DashboardItemSettingsComponent
  implements OnInit
{
  protected override cd: ChangeDetectorRef;

  constructor() {
    const cd = inject(ChangeDetectorRef);

    super();

    this.cd = cd;
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override setDefaultStyling() {
    if (this.item?.styles) this.item.styles.padding = true;
  }

  override get data(): DashboardItemTypeValueDisplay {
    return this.itemData?.valueDisplay;
  }

  protected override setDefault() {
    if (this.data == undefined)
      this.itemData.valueDisplay = {
        loggerId: null,
        deviceId: null,
        valueId: null,
        mode: ValueDisplayMode.LAST,
        rangeMode: DataDisplayDefaultRanges.CURRENT_DAY,
        range: null,
        showUnit: true,
        unitPrefix: '',
        showDate: true,
        showHeader: true,
        decimalPlaces: 2,
        consumption: false,
      };
  }

  protected readonly of = of;
}
